import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usersActions } from '@/rdx/actions';

const useAssigneeList = () => {
  const dispatch = useDispatch();
  const { isFetching, users, error, ownerOrgId } = useSelector((state) => ({
    isFetching: state.usersList?.isFetching,
    users: state.usersList?.users,
    error: state.usersList?.error,
    ownerOrgId: state.authentication?.ownerOrgId,
  }));

  React.useEffect(() => {
    dispatch(usersActions.fetchUsersList(ownerOrgId));
  }, [ownerOrgId]);

  return {
    assignees: users,
    error,
    isFetching,
  };
};

export default useAssigneeList;
